// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"icon_shadow__QXXQ_","icon":"icon_icon__1SW43"};